import { create } from 'zustand'

interface User {
  id: string
  email: string
  org_id: string
  role: 'admin' | 'member'
  status: 'pending' | 'approved' | 'suspended'
}

interface Project {
  id: string
  name: string
  description?: string
  created_by?: string
  target_system?: string
  connection_name?: string
  saviynt_url?: string
  saviynt_username?: string
  secret_count?: number  // Number of project secrets configured (values never stored in frontend)
}

interface AppState {
  user: User | null
  accessToken: string | null  // Short-lived JWT stored in memory only (never localStorage)
  currentProject: Project | null
  projects: Project[]

  setAuth: (user: User) => void
  clearAuth: () => void
  setAccessToken: (token: string) => void
  clearAccessToken: () => void
  setCurrentProject: (p: Project) => void
  setProjects: (ps: Project[]) => void
  updateProject: (updates: Partial<Project>) => void
}

export const useStore = create<AppState>((set) => ({
  user: null,
  accessToken: null,
  currentProject: null,
  projects: [],

  setAuth: (user) => set({ user }),

  clearAuth: () => {
    set({ user: null, accessToken: null, currentProject: null, projects: [] })
    window.location.href = '/login'
  },

  setAccessToken: (token) => set({ accessToken: token }),

  clearAccessToken: () => set({ accessToken: null }),

  setCurrentProject: (p) => set({ currentProject: p }),
  setProjects: (ps) => set({ projects: ps }),
  updateProject: (updates) =>
    set((state) => ({
      currentProject: state.currentProject
        ? { ...state.currentProject, ...updates }
        : null,
    })),
}))
